import { useCallback } from 'react';
import { isServer } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';

interface UseNavigationOptions {
    scrollToTop?: boolean;
    useWindowLocation?: boolean;
}

export function useNavigateTo(): (url: string, options?: UseNavigationOptions) => void {
    const history = useHistory();

    return useCallback(
        (url: string, options?: UseNavigationOptions) => {
            if (options?.useWindowLocation) {
                window.location.href = url;
            } else {
                history.push(url);
            }

            if (!isServer && !!options?.scrollToTop) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        [history],
    );
}
